import {
    IKhoLeadFilter,
    IKhoLeadRoundRobinVm,
    IKhoLeadThongKeVm,
    IKhoLeadVm,
} from "../../../models/response/crm-survey/IKhoLead";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objKhoLeadDefine = {
    LOAD_START: {} as IKhoLeadFilter,
    LOAD_SUCCESS: [] as IKhoLeadVm[],
    LOAD_ERROR: "",

    LOAD_THONGKE_START: 0,
    LOAD_THONGKE_SUCCESS: [] as IKhoLeadThongKeVm[],
    LOAD_THONGKE_ERROR: "",

    LOAD_ROUNDROBIN_START: 0,
    LOAD_ROUNDROBIN_SUCCESS: [] as IKhoLeadRoundRobinVm[],
    LOAD_ROUNDROBIN_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",

    /** Yêu cầu tải lại danh sách sau khi giao / chuyển / Unqualified / lưu cấu hình */
    NEED_RELOAD: undefined,
};

export const eKhoLeadActionTypeIds = generateActionTypeIds(objKhoLeadDefine, "KHO_LEAD");
export type IKhoLeadActionTypes = IGenericActionType<typeof objKhoLeadDefine, "KHO_LEAD">;
